import React, { useState } from 'react';
import styles from './Avatar.module.scss';

function getInitials(name) {
  if (!name) return '';
  
  const names = name.split(' ');
  if (names.length === 1) {
    return names[0].charAt(0).toUpperCase();
  }
  
  return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
}

function Avatar({ src, name, size = 'medium', className = '' }) {
  const [imageError, setImageError] = useState(false);
  const sizeClass = styles[`size_${size}`];
  const hasImage = Boolean(src) && !imageError;
  
  const handleImageError = () => {
    setImageError(true);
  };
  
  return (
    <div className={`${styles.avatar} ${sizeClass} ${className} ${hasImage ? '' : styles.noImage}`}>
      {hasImage ? (
        <img 
          src={src} 
          alt={name || 'User avatar'} 
          className={styles.image} 
          onError={handleImageError}
        />
      ) : (
        <div className={styles.initials}>{getInitials(name)}</div>
      )}
    </div>
  );
}

export default Avatar; 